export default {
  zoomInButton: 'zoom-in-button',
  zoomOutButton: 'zoom-out-button',
  zoomInputField: 'zoom-input-field',
  zoomInOutCmp: 'zoom-in-out-cmp',
};
